import { v4 as uuidv4 } from 'uuid'

// The Grpc request id is a session id and unique request id concatenated with a colon character so we can trace a user through our BE logs
// NOTE: The sessionId parameter is likely the user's id.
// In the context of the FNOL grpc request value we call the characters preceding the ":" the session id. So in Portal Next user id = session id
export default function(sessionId) {
  return `${sessionId}:${uuidv4()}`
}
